import { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { logger } from '@nx-frontend/shared/utils';

export function requestDurationLoggerRequestInterceptor(
  config: InternalAxiosRequestConfig
): InternalAxiosRequestConfig {
  return { ...config, metadata: { ...(config.metadata ?? {}), requestStart: performance.now() } };
}

function log({ url, params, metadata }: InternalAxiosRequestConfig): void {
  const requestStart = metadata?.requestStart;
  if (metadata?.cached) {
    logger.debug(`Axios: ${String(url)} returned from cache %j`, params || {});
  } else if (requestStart != null) {
    logger.debug(`Axios: ${String(url)} took ${Math.ceil(performance.now() - requestStart)}ms %j`, params || {});
  } else {
    logger.warn(`Axios: ${String(url)} requestStart is missing`);
  }
}
export function requestDurationLoggerResponseInterceptorOnFulfilled(response: AxiosResponse): AxiosResponse {
  log(response.config);
  return response;
}

export function requestDurationLoggerResponseInterceptorOnRejected(error: unknown): Promise<never> {
  if (error instanceof AxiosError && error.config != null) {
    log(error.config);
  } else {
    logger.warn('non axios error occurred. unable to calculate request duration');
  }
  return Promise.reject(error);
}
